import { useEffect, useState, type ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { api, ApiError } from "../api/staff";
import { StaffMeContext, type StaffMe } from "../context/StaffMeContext";

export function StaffGate({ children }: { children: ReactNode }) {
  const [state, setState] = useState<
    { kind: "loading" } | { kind: "ok"; me: StaffMe } | { kind: "deny" }
  >({ kind: "loading" });
  console.log("StaffGate render", state.kind);

  useEffect(() => {
    let cancelled = false;
    api<StaffMe>("/staff/auth/me")
      .then((me) => {
        if (cancelled) return;
        setState({ kind: "ok", me });
      })
      .catch((err) => {
        if (cancelled) return;
        if (err instanceof ApiError && err.status === 401) {
          setState({ kind: "deny" });
          return;
        }
        setState({ kind: "deny" });
      });
    return () => { cancelled = true; };
  }, []);

  if (state.kind === "loading") {
    return (
      <div style={{ display: "grid", minHeight: "100vh", placeItems: "center", color: "rgba(7,10,13,0.4)", fontSize: 13 }}>
        Chargement…
      </div>
    );
  }
  if (state.kind === "deny") {
    return <Navigate to="/login" replace />;
  }
  
  console.log("StaffGate Provider rendering with value:", state.me);
  
  return (
    <StaffMeContext.Provider value={state.me}>
      {children}
    </StaffMeContext.Provider>
  );
}
